import { createAction } from '@src/redux/helpers/createAction';
import { validateTINSaga } from './sagas';
import { VALIDATE_TIN, SET_TIN, RESET_TIN_INFO } from './constants';

export const validateTIN = (req, onSuccess, onError) => {
  return createAction({
    type: VALIDATE_TIN,
    cache: false,
    payload: req,
    meta: {
      onSuccess,
      onError,
      async: validateTINSaga,
    },
  });
};

export const setTIN = (payload) => {
  return createAction({
    type: SET_TIN,
    payload,
  });
};

export const resetTINInfo = (payload) => {
  return createAction({
    type: RESET_TIN_INFO,
    payload,
  });
};
